export const urlPersistir = 'ColaboradorProfissional';
export const UrlColaboradorProfissional = "ColaboradorProfissional";
export const UrlBuscarPaginado = "ColaboradorProfissional/BuscarPaginado";
export const UrlBuscarPorIdConta = "ColaboradorProfissional/BuscarPorIdConta";
export const UrlServico = "Servico";
export const ModalTexto = "Deseja remover o item?"

export const propertyLabels: {[key: string]: { label: string; ordem?: number }; } = {
    nomeColaborador: { label: "Nome", ordem: 1 },
    razaoSocial: { label: "Loja", ordem: 2 },
    descricaoServico: { label: "Serviço", ordem: 3 },
    descricao: { label: "Descrição", ordem: 4 }, 
  };